import type { FC } from 'react';
import c from 'classnames';
import { PapiDeviation } from '@wix/da-papi-types';
import Stats from '@wix/da-shared-react/pkg/Stats';

import s from './DeviationStats.scss';

interface Props {
  deviation: PapiDeviation;
  className?: string;
}

const DeviationStats: FC<Props> = ({ deviation, className }) => {
  return (
    <Stats
      statWrapperClassName={c(s['stats'], className)}
      statClassName={s['stat']}
      deviation={deviation}
      onlyNumbers
      withSubscriberCount
      withPrivateCollectionsCount={!!deviation.stats?.privatelyCollected}
      withPremiumDownloadCount
      withViewCount
      withCommentControl={!!deviation.stats?.comments}
      withBadges={false}
      withDaProtectIndicator={false}
      withNoAiIndicator={false}
      withUserList={false}
    />
  );
};
DeviationStats.displayName = 'DeviationStats';

export default DeviationStats;
